import { createFileRoute, redirect } from "@tanstack/react-router";

// Index always defers to the templates tab.
export const Route = createFileRoute("/_admin/prompt-engine/")({
  beforeLoad: () => {
    throw redirect({ to: "/prompt-engine/templates", replace: true });
  },
  component: () => null,
});
